import { useState } from "react";

import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto";
import { ExpandableTextarea } from "../../../components/ExpandableTextarea/ExpandableTextarea";
import { useIsReadOnly } from "../../../utilities/helpers/roleUtilities";

type WorkOrderCellProps = {
  stoppage: StoppageDto
  handleWorkOrderChange: (stoppage: StoppageDto) => Promise<void>
}

const WorkOrderCell: React.FC<WorkOrderCellProps> = ({ stoppage, handleWorkOrderChange }) => {
  const isReadOnly = useIsReadOnly();
  const [textState, setTextState] = useState<string>(stoppage.workOrder || '');

  return (
    <div className="w-full">
      <ExpandableTextarea
        disabled={isReadOnly}
        value={textState}
        placeholder="No Work Order"
        onChange={(e) => setTextState(e.target.value)}
        onSubmit={async () => {
          await handleWorkOrderChange(new StoppageDto({ ...stoppage, workOrder: textState }));
        }}
      />
    </div>
  )
}

export default WorkOrderCell